import React from "react";

export default function Result({ giphy }) {
  console.log(giphy);
  const GiphyLoop = giphy.map(function (giphy, i) {
    if (i < 10) {
      console.log(i);
      return (
        <div key={i}>
          <img
            src={giphy.images.fixed_height_small.url}
            alt={giphy.title}
            height={giphy.images.fixed_height_small.height}
          />
        </div>
      );
    } else {
      return null;
    }
  });

  return <div className="giphy">{GiphyLoop}</div>;
}
